import { NavLink } from "react-router-dom";

import { ListItem, ListItemText } from "@material-ui/core";

import { getLastUsedSubaccountId } from "src/util/subaccountUsage";

import {
  useTenant,
  useAdminSubaccountMemberships
} from "./LoggedInAdminProvider";
import { SubaccountMembership } from "./SubaccountProvider";

export default function BackToSubaccountListItem({
  className
}: {
  className?: string;
}): JSX.Element | null {
  const tenant = useTenant()!;
  const memberships = useAdminSubaccountMemberships()!;
  const lastUsedSubaccountId = getLastUsedSubaccountId();

  let backToSubaccount: SubaccountMembership | undefined;
  if (memberships.length === 1) {
    backToSubaccount = memberships[0];
  } else if (lastUsedSubaccountId) {
    backToSubaccount = memberships.find(
      m => m.subaccount.id === lastUsedSubaccountId
    );
  }

  if (!backToSubaccount) {
    return null;
  }

  return (
    <ListItem
      dense
      button
      className={className}
      component={NavLink}
      to={
        tenant.isUsingSubaccounts
          ? `/subaccounts/${backToSubaccount.subaccount.id}/campaigns`
          : `/admin/campaigns`
      }
      activeStyle={{ fontWeight: 999 }}
    >
      <ListItemText
        disableTypography
        primary={`Back to ${backToSubaccount.subaccount.name}`}
      />
    </ListItem>
  );
}
